import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { HotWaterOutagesPage, HotWaterOutagesPageProps } from "./HotWaterOutagesPage";

export const EMPTY_PAGE_CONTENT: HotWaterOutagesPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/outages-faults/hot-water";

export const HotWaterOutagesPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<HotWaterOutagesPageProps>("hot_water_outage_page", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <HotWaterOutagesPage {...routeProps} {...content} />;
};
